"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.addSuccessHandler = exports.addUnexpectedErrorHandler = exports.success = exports.warn = exports.userError = exports.toast = exports.unexpectedError = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _moment = _interopRequireDefault(require("moment"));

var _uuid = require("uuid");

var _notificationsMerge = require("../helpers/notificationsMerge");

var _INotification = require("../models/INotification");

var unexpectedError = function unexpectedError(localizableMessage, correlationId, options) {
  if (typeof correlationId !== 'string') {
    if (correlationId.meta !== undefined) {
      correlationId = correlationId.meta.correlationId;
    } else {
      correlationId = '';
    }
  }

  if (typeof localizableMessage === 'string') {
    localizableMessage = {
      key: localizableMessage,
      options: {}
    };
  }

  if (localizableMessage.options === undefined) {
    localizableMessage.options = {};
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({
    autoClose: false,
    severity: _INotification.NotificationSeverity.error,
    type: _INotification.NotificationType.toast
  }, options), {}, {
    id: correlationId || (0, _uuid.v4)(),
    createdDateTime: (0, _moment.default)(),
    localizableMessage: localizableMessage,
    correlationId: correlationId
  });
};

exports.unexpectedError = unexpectedError;

var toast = function toast(localizableMessage, severity, options) {
  if (typeof localizableMessage === 'string') {
    localizableMessage = {
      key: localizableMessage,
      options: {}
    };
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({
    autoClose: false,
    severity: severity
  }, options), {}, {
    type: _INotification.NotificationType.toast,
    id: (0, _uuid.v4)(),
    createdDateTime: (0, _moment.default)(),
    localizableMessage: localizableMessage
  });
};

exports.toast = toast;

var userError = function userError(localizableMessage, options) {
  return toast(localizableMessage, _INotification.NotificationSeverity.userError, options);
};

exports.userError = userError;

var warn = function warn(localizableMessage, options) {
  return toast(localizableMessage, _INotification.NotificationSeverity.warn, options);
};

exports.warn = warn;

var success = function success(localizableMessage, options) {
  return toast(localizableMessage, _INotification.NotificationSeverity.success, (0, _objectSpread2.default)({
    autoClose: undefined
  }, options));
};

exports.success = success;

var addUnexpectedErrorHandler = function addUnexpectedErrorHandler(errorActionType, localizableMessageKey, registry) {
  var unexpectedErrorReducer = function unexpectedErrorReducer(state, action) {
    if (action.type !== errorActionType) {
      return state;
    }

    var nextState = (0, _notificationsMerge.addNotification)(state, unexpectedError(localizableMessageKey, action));
    return nextState;
  };

  registry.add(unexpectedErrorReducer);
};

exports.addUnexpectedErrorHandler = addUnexpectedErrorHandler;

var addSuccessHandler = function addSuccessHandler(actionType, localizableMessageKey, registry) {
  var successReducer = function successReducer(state, action) {
    if (action.type !== actionType) {
      return state;
    }

    var nextState = (0, _notificationsMerge.addNotification)(state, success(localizableMessageKey));
    return nextState;
  };

  registry.add(successReducer);
};

exports.addSuccessHandler = addSuccessHandler;